'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Seasonality.SpecialEventsGrid', dependencies).controller('SpecialEventsGridController', require('./controllers/SpecialEventsGridController')).directive('rmSpecialEventsGridNewCalendar', require('./directives/SpecialEventsGridNewCalendarDirective')).directive('rmSpecialEventsGrid', require('./directives/SpecialEventsGridDirective'));